import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createDataHook,
  createGetAction,
  createLoadingHook,
  createRestActions,
  createRestStore,
  replaceStoreData,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { headcountYearlyTrendEnvelopeMapper } from '../headcountMappers';
import type { HeadcountYearlyTrendApiResponse, HeadcountYearlyTrendPoint } from '../headcountTypes';

const actionConfig = {
  resourcePath: '/dashboards/headcount/yearly-trend',
};

type HeadcountYearlyTrendState = RestStoreState<HeadcountYearlyTrendPoint>;

const genericActions = createRestActions<HeadcountYearlyTrendPoint>(actionConfig);

const headcountYearlyTrendActions = {
  ...genericActions,
  loadRange: (fromYear: number, toYear: number) => async ({
    dispatch,
    getState,
  }: StoreActionApi<HeadcountYearlyTrendState>) => {
    const getAction = createGetAction<HeadcountYearlyTrendPoint>({
      ...actionConfig,
      reducer: data => ({ dispatch: d }) => {
        const envelope = (Array.isArray(data) ? data[0] : data) as unknown as HeadcountYearlyTrendApiResponse;
        const points = envelope ? headcountYearlyTrendEnvelopeMapper.toModel(envelope) : [];
        d(replaceStoreData(points));
      },
    });
    await dispatch(getAction({ params: { fromYear, toYear } }));
    return getState().data;
  },
  clearYearlyTrend: () => ({ setState }: StoreActionApi<HeadcountYearlyTrendState>) => {
    setState({ data: [], isLoading: false, changes: [] });
  },
};

export const HeadcountYearlyTrendStore = createRestStore<HeadcountYearlyTrendPoint>({
  actions: headcountYearlyTrendActions,
  actionConfig,
  containerDisplayName: 'headcount-yearly-trend-container',
  onInitAction: null,
});

export const useHeadcountYearlyTrendData = createDataHook(HeadcountYearlyTrendStore);
export const useHeadcountYearlyTrendIsLoading = createLoadingHook(HeadcountYearlyTrendStore);
export const useHeadcountYearlyTrendActions = createActionsHook(HeadcountYearlyTrendStore);
